import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Send } from "lucide-react";

export default function ContactForm() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [values, setValues] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const e = {};
    if (!values.name.trim()) e.name = t("contact.errors.name");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim()))
      e.email = t("contact.errors.email");
    if (values.message.trim().length < 10) e.message = t("contact.errors.message");
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const onSubmit = (ev) => {
    ev.preventDefault();
    if (!validate()) return;
    setSubmitting(true);
    // Frontend only: emulate a small submit delay then redirect
    setTimeout(() => {
      navigate("/thank_you");
    }, 250);
  };

  const on = (k) => (e) => setValues({ ...values, [k]: e.target.value });

  return (
    <form className="ec-form" onSubmit={onSubmit} noValidate>
      <div className="ec-field">
        <label htmlFor="ec-name">{t("contact.name")}</label>
        <input
          id="ec-name"
          type="text"
          autoComplete="name"
          value={values.name}
          onChange={on("name")}
          placeholder={t("contact.name_placeholder")}
        />
        {errors.name && <span className="ec-error">{errors.name}</span>}
      </div>
      <div className="ec-field">
        <label htmlFor="ec-email">{t("contact.email")}</label>
        <input
          id="ec-email"
          type="email"
          autoComplete="email"
          value={values.email}
          onChange={on("email")}
          placeholder={t("contact.email_placeholder")}
        />
        {errors.email && <span className="ec-error">{errors.email}</span>}
      </div>
      <div className="ec-field">
        <label htmlFor="ec-message">{t("contact.message")}</label>
        <textarea
          id="ec-message"
          rows={5}
          value={values.message}
          onChange={on("message")}
          placeholder={t("contact.message_placeholder")}
        />
        {errors.message && <span className="ec-error">{errors.message}</span>}
      </div>
      <button type="submit" className="ec-btn ec-btn--primary ec-form-submit" disabled={submitting}>
        <Send size={16} />
        <span>{t("contact.submit")}</span>
      </button>
      <p className="ec-form-note">{t("contact.privacy_note")}</p>
    </form>
  );
}
